// removed by extract-text-webpack-plugin
module.exports = {"title":"_1LXoh0iIbYRTakgFFOVdgX","buttonNew":"_27SrxpGQaNqRGEh43QRLuI","available":"_3h9aLZ74mGwsTCxpgwx98n","start":"_1j-Jit8KKpbEX0BXfoAjI2","searchField":"_22QPu8gTg7K8m8gijDXaeU","filters":"lBM3kmq_DKEuyswH7XyRT","filter":"_2mDMv-qL2iFysqpKhJj2n5","label":"_2drYSNesfilgX8vJQ6Ux3C","item":"ItcXtRz8avgBUPW5gXxXB"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Work/style.scss
// module id = 1252
// module chunks = 0